export default __webpack_public_path__ + "static/media/Alma_logo_2018.4d7120e0.jpg";